export default '#,##0%';